  <!-- Sidebar -->
  <nz-sider
    class="bg-white sidebar-container smooth-sidebar d-none d-md-block"
    nzBreakpoint="lg"
    [nzWidth]="200"
    [nzCollapsedWidth]="60"
    [nzCollapsedWidth]="sidebarWidth"
    nzCollapsible
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
    style="position: fixed; transition: all 0.3s ease-in"
  >
    <app-sidebar [isCollapsed]="isCollapsed"></app-sidebar>
  </nz-sider>

  <!-- Main Layout -->
  <nz-layout
    class="smooth-main"
    [style.marginLeft.px]="isCollapsed ? sidebarWidth : 200"
    style="min-height: 100vh; transition: all 0.3s ease-in"
  >
    <!-- Header -->
    <nz-header
      class="smooth-header"
      [style.left.px]="isCollapsed ? sidebarWidth : 200"
      style="
        transition: all 0.3s ease-in;
        position: fixed;
        top: 0;
        right: 0;
        height: 64px;
        z-index: 1000;
        background: #fff;
        padding: 0;
      "
    >
      <app-header
        class="header-content"
        [isInsuranceActive]="isInsuranceActive"
        [isCollapsed]="isCollapsed"
        (toggle)="toggleSidebar()"
      ></app-header>
    </nz-header>

    <!-- Content -->
    <nz-content style="padding-top: 64px; overflow: initial">
      <router-outlet> </router-outlet>
      <!-- <copilot-popup [(open)]="copilotOpen" title="Ask Matrix" /> -->
      <app-chat-popup></app-chat-popup>
    </nz-content>
  </nz-layout>
